import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Apod from "@/pages/Apod";
import MarsRover from "@/pages/MarsRover";
import EarthFromSpace from "@/pages/EarthFromSpace";
import AsteroidTracker from "@/pages/AsteroidTracker";
import SpaceGallery from "@/pages/SpaceGallery";
import PlanetFacts from "@/pages/PlanetFacts";
import SpaceToday from "@/pages/SpaceToday";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors closeButton />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/apod" element={<Apod />} />
          <Route path="/mars-rover" element={<MarsRover />} />
          <Route path="/earth" element={<EarthFromSpace />} />
          <Route path="/asteroids" element={<AsteroidTracker />} />
          <Route path="/gallery" element={<SpaceGallery />} />
          <Route path="/planets" element={<PlanetFacts />} />
          <Route path="/today" element={<SpaceToday />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
